/** JSON Resume-style ISO 8601 fragment: full date, year-month, or year only. */
export const ISO8601_DATE_FRAGMENT_REGEX =
  /^([12]\d{3}-[01]\d-[0-3]\d|[12]\d{3}-[01]\d|[12]\d{3})$/;

const LLM_OPTIONAL_DATE_PLACEHOLDER =
  /present|ongoing|current|now|tbd|to\s*date|n\/a/i;

/**
 * Strips placeholders and invalid strings LLMs often put in optional date fields (e.g. "Present").
 * Returns a valid ISO fragment or undefined.
 */
export function normalizeOptionalIsoDate(val: unknown): string | undefined {
  if (val === undefined || val === null) {
    return undefined;
  }
  if (typeof val !== "string") {
    return undefined;
  }
  const s = val.trim();
  if (s === "") {
    return undefined;
  }
  if (LLM_OPTIONAL_DATE_PLACEHOLDER.test(s)) {
    return undefined;
  }
  if (ISO8601_DATE_FRAGMENT_REGEX.test(s)) {
    return s;
  }
  return undefined;
}
